/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';
import type {UserLimitsRemoveRequest} from '../models/UserLimitsRemoveRequest';
import type {UserLimitsSaveRequest} from '../models/UserLimitsSaveRequest';

export interface GetUserCommonLimits$Request {
    userId: number;
}

export interface GetUserCommonLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserCommonLimitsRequest = createAction<PayloadData<void, GetUserCommonLimits$Request>>('USER_COMMON_LIMITS__GET_USER_COMMON_LIMITS__REQUEST');
export const getUserCommonLimitsSuccess = createAction<PayloadData<Array<Limit>, GetUserCommonLimits$Request>>('USER_COMMON_LIMITS__GET_USER_COMMON_LIMITS__SUCCESS');
export const getUserCommonLimitsFailure = createAction<PayloadData<Error, GetUserCommonLimits$Request, true>>('USER_COMMON_LIMITS__GET_USER_COMMON_LIMITS__FAILURE');

export const getUserCommonLimitsActions = [
    getUserCommonLimitsRequest,
    getUserCommonLimitsSuccess,
    getUserCommonLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserCommonLimits = (meta: GetUserCommonLimits$Request, config?: GetUserCommonLimits$Config) => {
    return {
        CALL_API: {
            types: getUserCommonLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/commons-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveUserCommonLimit$Request {
    userId: number;
    userLimitsRemoveRequest: UserLimitsRemoveRequest;
}

export interface RemoveUserCommonLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeUserCommonLimitRequest = createAction<PayloadData<void, RemoveUserCommonLimit$Request>>('USER_COMMON_LIMITS__REMOVE_USER_COMMON_LIMIT__REQUEST');
export const removeUserCommonLimitSuccess = createAction<PayloadData<void, RemoveUserCommonLimit$Request>>('USER_COMMON_LIMITS__REMOVE_USER_COMMON_LIMIT__SUCCESS');
export const removeUserCommonLimitFailure = createAction<PayloadData<Error, RemoveUserCommonLimit$Request, true>>('USER_COMMON_LIMITS__REMOVE_USER_COMMON_LIMIT__FAILURE');

export const removeUserCommonLimitActions = [
    removeUserCommonLimitRequest,
    removeUserCommonLimitSuccess,
    removeUserCommonLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsRemoveRequest} meta.userLimitsRemoveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeUserCommonLimit = (meta: RemoveUserCommonLimit$Request, config?: RemoveUserCommonLimit$Config) => {
    return {
        CALL_API: {
            types: removeUserCommonLimitActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/commons-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsRemoveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserCommonLimit$Request {
    userId: number;
    userLimitsSaveRequest: UserLimitsSaveRequest;
}

export interface SaveUserCommonLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserCommonLimitRequest = createAction<PayloadData<void, SaveUserCommonLimit$Request>>('USER_COMMON_LIMITS__SAVE_USER_COMMON_LIMIT__REQUEST');
export const saveUserCommonLimitSuccess = createAction<PayloadData<void, SaveUserCommonLimit$Request>>('USER_COMMON_LIMITS__SAVE_USER_COMMON_LIMIT__SUCCESS');
export const saveUserCommonLimitFailure = createAction<PayloadData<Error, SaveUserCommonLimit$Request, true>>('USER_COMMON_LIMITS__SAVE_USER_COMMON_LIMIT__FAILURE');

export const saveUserCommonLimitActions = [
    saveUserCommonLimitRequest,
    saveUserCommonLimitSuccess,
    saveUserCommonLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsSaveRequest} meta.userLimitsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserCommonLimit = (meta: SaveUserCommonLimit$Request, config?: SaveUserCommonLimit$Config) => {
    return {
        CALL_API: {
            types: saveUserCommonLimitActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/users/${meta.userId}/commons-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

